// extracted by mini-css-extract-plugin
export default {"block":"PlanFeatureStyle_block__kOX0h","intial":"PlanFeatureStyle_intial__lCXGK","value":"PlanFeatureStyle_value__nG9bC"};